import { CSSProperties } from "react"
import { none, Option } from "widgets-for-react"
import { pushTranslateAction as pushTranslateActionDNB } from "../DeNieuweBibliotheek/custom_components/components/datalayer"
import { pushTranslateAction as pushTranslateActionWhiteLabel } from "../Generic/custom_components/components/datalayer"
import { PageType, showOnHome, showOnHomeAndActivities } from "./features/showAnnouncementOnPage"
import { fromNullable, valueOrExcept } from "./utils/option"


type Switch = 'on' | 'off'

export interface Features {
  automatedTranslations: 'off' | { iconFill: CSSProperties["color"], pushDataLayerEvent: (label: string) => void }
  branchLocalization: Switch
  showAnnouncementOnPage: (page: PageType) => boolean
  privacyStatementUrl: string
}

const vbp: Features = {
  automatedTranslations: { iconFill: '#090b09', pushDataLayerEvent: (label: string) => pushTranslateActionWhiteLabel(label) },
  branchLocalization: 'off',
  showAnnouncementOnPage: showOnHome,
  privacyStatementUrl: '/privacyverklaring'
}

const bkw: Features = { ...vbp }

const dnb: Features = {
  ...vbp,
  automatedTranslations: { iconFill: '#ffffff', pushDataLayerEvent: (label: string) => pushTranslateActionDNB(label) },
  privacyStatementUrl: '/privacy'
}

const flevo: Features = {
  ...vbp,
  automatedTranslations: 'off',
  showAnnouncementOnPage: showOnHomeAndActivities,
  privacyStatementUrl: '/privacy'
}

const twente: Features = {
  ...vbp,
  automatedTranslations: 'off'
}

// Define LibraryIDs and guard clause
const libraryIDs = ['vbp', 'bkw', 'flevo', 'twente', 'dnb'] as const
export type LibraryID = typeof libraryIDs[number]
const isLibraryID = (id: string): id is LibraryID => libraryIDs.includes(id as LibraryID)

// Define implementations of Library for each LibraryID
type FeatureSets = { [library in LibraryID]: Features }
const libraryCustomizations: FeatureSets = { vbp, bkw, flevo, twente, dnb }

// Set application wide Library at runtime
let _features: Option<Features> = none()
export const setFeatures = (id: string) => {
  if (!isLibraryID(id)) throw new TypeError(`Library ID must be one of: ${libraryIDs.join(', ')}`)
  _features = fromNullable(libraryCustomizations[id])
}

// Get Features at runtime
export const features = (): Features => valueOrExcept(_features, "Features have not yet been set. Make sure to call features() within the context of the React Application component.")
